export default function Node_Auth() {
  return <div>Node_Auth Component</div>;
}
